import { RoleName } from "@/core/constants";

export const workforceRoutes = [
  {
    path: "/workforce/educators",
    name: "educatorList",
    meta: {
      title: "Educators",
      tag: "common.educators",
      localise: true,
      roles: `${RoleName.RegionalTrainingManager},` +
        `${RoleName.GlobalTrainingManager},` +
        `${RoleName.UnionTrainingManager},` +
        `${RoleName.UnionAdministrator},` +
        `${RoleName.IrisAdministrator}` },
    component: () =>
      import(/* webpackChunkName: "workforce" */ "@/views/workforce/EducatorList.vue"),
  },

];
